import { WebStorageStateStore } from 'oidc-client-ts'
import type { AuthProviderProps } from 'react-oidc-context'

export function createOidcConfig(): AuthProviderProps {
  const keycloakUrl =
    (import.meta.env.VITE_KEYCLOAK_URL as string) || 'https://iam.svc.cloudsent.com'
  const realm = (import.meta.env.VITE_KEYCLOAK_REALM as string) || 'corp'
  const clientId = (import.meta.env.VITE_KEYCLOAK_CLIENT_ID as string) || 'user'

  const authority = `${keycloakUrl}/realms/${realm}`
  const origin = window.location.origin

  return {
    authority,
    client_id: clientId,
    redirect_uri: `${origin}/callback`,
    post_logout_redirect_uri: `${origin}/login`,
    silent_redirect_uri: `${origin}/silent-check-sso.html`,
    response_type: 'code',
    scope: 'openid profile email',
    automaticSilentRenew: true,
    loadUserInfo: true,
    includeIdTokenInSilentRenew: true,
    onSigninCallback: () => {
      window.history.replaceState({}, document.title, window.location.pathname)
    },
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    metadata: {
      issuer: authority,
      authorization_endpoint: `${authority}/protocol/openid-connect/auth`,
      token_endpoint: `${authority}/protocol/openid-connect/token`,
      userinfo_endpoint: `${authority}/protocol/openid-connect/userinfo`,
      end_session_endpoint: `${authority}/protocol/openid-connect/logout`,
      jwks_uri: `${authority}/protocol/openid-connect/certs`,
    },
  }
}
